import React from 'react'
import { Dropdown, useModalContext } from '@sketch/components'
import { ShareForShareDropdown } from '../ShareActionsDropdown'
import { useIsProfileCreated } from '../../../../community/hooks'
import {
  UnpublishPublicationModal,
  PublishDocumentNowModal,
} from '../../../../community/modals'

export interface PublishDocumentOptionProps {
  workspaceIdentifier: string
  share: ShareForShareDropdown
  isPublished: boolean
  publicCommentsEnabled: boolean
  publicInspectEnabled: boolean
}

export const PublishDocumentOption: React.FC<PublishDocumentOptionProps> = ({
  workspaceIdentifier,
  share,
  isPublished,
  publicCommentsEnabled,
  publicInspectEnabled,
}) => {
  const { showModal } = useModalContext()

  const { isProfileCreated } = useIsProfileCreated(workspaceIdentifier)
  const isInDrafts = share.project?.projectType === 'PERSONAL_DRAFTS'

  if (!isProfileCreated || isInDrafts) {
    return null
  }

  const showPublishConfirmation = () => {
    showModal(PublishDocumentNowModal, {
      shareName: share.name,
      shareIdentifier: share.identifier,
      workspaceIdentifier,
      publicCommentsEnabled,
      publicInspectEnabled,
    })
  }

  const showUnpublishModal = () => {
    showModal(UnpublishPublicationModal, {
      shareName: share.name,
      shareIdentifier: share.identifier,
      workspaceIdentifier,
      publicCommentsEnabled,
      publicInspectEnabled,
      publicAccessLevel: share.publicAccessLevel,
    })
  }

  const handleClick = () => {
    if (isPublished) {
      showUnpublishModal()
    } else {
      showPublishConfirmation()
    }
  }

  return (
    <>
      <Dropdown.Divider />
      <Dropdown.Item
        onClick={handleClick}
        intent={isPublished ? 'negative' : 'primary'}
      >
        {isPublished ? 'Remove from profile…' : 'Publish to Public profile'}
      </Dropdown.Item>
    </>
  )
}
